import { marked } from 'marked';

const normalizePlainText = (text: string) => text.replace(/\s+/g, ' ').trim();

const separatorTags = new Set([
  'blockquote',
  'br',
  'div',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'li',
  'ol',
  'p',
  'pre',
  'section',
  'table',
  'td',
  'th',
  'tr',
  'ul'
]);

const collectNodeText = (node: Node): string => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent || '';
  }

  if (!(node instanceof HTMLElement)) {
    return '';
  }

  if (node.tagName.toLowerCase() === 'img') {
    return '';
  }

  if (node.tagName.toLowerCase() === 'br') {
    return ' ';
  }

  const text = Array.from(node.childNodes)
    .map(childNode => collectNodeText(childNode))
    .join('');

  return separatorTags.has(node.tagName.toLowerCase()) ? ` ${text} ` : text;
};

const extractPlainTextFromHtml = (html: string) => {
  const documentFragment = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  return normalizePlainText(collectNodeText(documentFragment.body));
};

export const buildInformationPreview = (description: string) => {
  const html = marked.parse(description, { breaks: true, gfm: true });
  const plainText = extractPlainTextFromHtml(typeof html === 'string' ? html : '');

  return plainText.length > 50 ? `${plainText.slice(0, 50)} ...` : plainText;
};
